<div class="item-grid-container">
  <h2 class="mb-2">
    <span class="px-2 py-3 rounded-0 ms-3">
      Close Retailer Account</span
    >
  </h2>
  <div class="retailer-details-blk">
    <mat-card class="shadow-none">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-2 col-xs-12">
          <div class="account-details">
            <div class="row justify-content-center">
              <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12">
                <div class="retailer-account-columns">
                  <ul class="list-unstyled">
                    <li>
                      <h4 class="">
                        {{'pages.CloseAccount.Account' | translate }} :
                        <span class="float-end fw-nornal">
                          {{ retailerInfo.retailerAccountNum }}</span
                        >
                      </h4>
                    </li>
                    <li>
                      <h4 class="">
                        {{'pages.ManageRetailer.RetailerName' | translate }} :
                        <span class="float-end fw-nornal">
                          {{ retailerInfo.dbaName }}</span
                        >
                      </h4>
                    </li>
                    <li>
                      <h4 class="">
                        {{'pages.ManageRetailer.DBAName' | translate }} :
                        <span class="float-end fw-nornal">
                          {{ retailerInfo.dbaName }}</span
                        >
                      </h4>
                    </li>
                    <li>
                      <h4 class="">
                        {{
                          retailerInfo.retailerType.toLowerCase() == "prepaid"
                            ? "Refund"
                            : "Payment "
                        }}
                        {{'pages.ManageRetailer.Balance' | translate }}:
                        <span class="float-end fw-nornal">
                          $
                          {{
                            retailerInfo.retailerType.toLowerCase() == "prepaid"
                              ? retailerInfo.currentAmount
                              : retailerInfo.invoiceDue
                          }}
                          - {{ retailerInfo.paymentOptionType }}</span
                        >
                      </h4>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col-lg-5 col-md-5 col-sm-5 offset-1 col-xs-12">
                <div class="retailer-account-columns">
                  <ul class="list-unstyled">
                    <li>
                      <h4 class="">
                        {{'pages.CloseAccount.AccountType' | translate }} :
                        <span class="float-end fw-nornal">
                          {{ retailerInfo.retailerType }}</span
                        >
                      </h4>
                    </li>
                    <li>
                      <h4 class="">
                        {{'pages.CloseAccount.Businessname' | translate }} :
                        <span class="float-end fw-nornal">
                          {{ retailerInfo.businessName }}</span
                        >
                      </h4>
                    </li>
                    <li class="mb-4">
                      <!-- If retailer type : prepaid then show refund status based on balance  -->
                      <h4 class=" mb-0" *ngIf=" retailerInfo.retailerType.toLowerCase() ==
                      'prepaid'">{{'pages.Refundreport.RefundStatus' | translate }} :
                        <ng-container
                          *ngIf="retailerInfo.currentAmount > 0 else prepaidPaid
                          "
                          class="float-end fw-nornal"
                        >
                        <span  class="float-end fw-nornal" > Pending</span> <br />
                          <span
                            class="text-underline cur-point text-small"
                            (click)="onNotifyRetailer()"
                            >Notify retailer</span
                          >
                        </ng-container>
                        <ng-template #prepaidPaid> <span class="float-end fw-nornal">{{retailerInfo.paymentStatus}}</span>
                        </ng-template>
                      </h4>

                      <h4 class=" mb-0" *ngIf=" retailerInfo.retailerType.toLowerCase() ==
                      'postpaid'">
                      {{ 'pages.Paymentreport.PaymentStatus' | translate }} :
                        <ng-container 
                          *ngIf="retailerInfo.invoiceDue >0 && retailerInfo.invoiceDue != null else postpaidPaid
                          "
                         
                        >
                        <span  class="float-end fw-nornal" >
                            {{
                              retailerInfo.paymentStatus == "Pending Approval"
                                ? retailerInfo.paymentStatus
                                : "Pending"
                            }}
                        </span>
                          <br /><span
                            class="text-underline cur-point text-small"
                            (click)="onNotifyRetailer()"
                            >Notify retailer</span
                          >
                        </ng-container>

                        <ng-template #postpaidPaid><span class="float-end">Paid</span></ng-template>

                      </h4>
                    </li>
                    <li>
                      <h4 class="">
                        {{'pages.CloseAccount.Reasonforclosing' | translate }} :
                        <span class="float-end fw-nornal">
                          {{ retailerInfo.retailerStatusReason }}</span
                        >
                      </h4>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="message-container ms-4">
              <h4
                class="text-underline mb-4 cur-point"
                (click)="addMessage()"
              >
                <i class="mi mi-{{ iconClass }} small-icon"></i> Personalize
                close account message
              </h4>
              <ng-container *ngIf="showMessageContainer">
                <mat-form-field lass="message-box" appearance="outline">
                  <textarea
                    matInput
                    #comment
                    maxlength="100"
                    [(ngModel)]="message"
                    [required] = isSendMessage
                    placeholder="Enter your message"
                  ></textarea>
                  <p class="text-end mb-0">{{comment.value.length}}/100
                  <p>
                </mat-form-field>
                <mat-checkbox
                  color="primary"
                  class="example-margin d-block m-0"
                  [(ngModel)]="isSendMessage"
                  >Send Message</mat-checkbox
                >
              </ng-container>
            </div>
          </div>
          <div class="close-account-footer mb-4 text-center">
            <button
              mat-raised-button
              color="primary"
              [disabled]="checkSubmitDisplayed()"
              (click)="onCloseRetailer()"
            > 
            {{ 'pages.newRetailer.close' | translate }}
            </button>
            <button
              mat-stroked-button
              color="primary"
              class="ms-3"
              mat-dialog-close
              routerLinkActive="router-link-active"
            >
              {{ 'pages.newRetailer.cancel' | translate }}
            </button>
          </div>
        </div>
      </div>
    </mat-card>
  </div>
</div>
